// extracted by mini-css-extract-plugin
export default {"mainBlock":"mainBlock__CCn4r1VI","fabContainer":"fabContainer__HzSHaVy8"};